import React from 'react';
import { Link } from 'react-router-dom';
import { 
    Typography,
    Icon
} from '@material-ui/core';

const RightSideNav = (props) => {
    return (
        <> 
            <Link to="/register" className={props.navbar ? "show-reg-form" : props.bgColor === "transparent" ? "show-reg-form-2" : "show-reg-form" }>
                <Icon fontSize="medium">
                    person_add
                </Icon>
                <Typography variant="caption" display="block" gutterBottom>
                    Sign Up
                </Typography>
            </Link>

            <Link to={`/login`} className={props.navbar ? "show-reg-form" : props.bgColor === "transparent" ? "show-reg-form-2" : "show-reg-form" }>
                <Icon fontSize="medium">
                    lock
                </Icon>
                <Typography variant="caption" display="block" gutterBottom>
                    Login
                </Typography>
            </Link>
        </> 
    );
};

export default RightSideNav;